import { Error as ApiError, HttpResponse } from "@workspace/auth-client/client";

/**
 * Type guard to check if an error is an API error response
 */
export function isApiError(error: unknown): error is HttpResponse<unknown, ApiError> {
  return (
    typeof error === "object" &&
    error !== null &&
    "error" in error &&
    typeof (error as { error: unknown }).error === "object" &&
    (error as { error: unknown }).error !== null &&
    "code" in (error as { error: { code: unknown } }).error
  );
}

/**
 * Extract error message from various error types
 */
export function getErrorMessage(error: unknown): string {
  if (isApiError(error)) {
    return error.error.message || "An error occurred";
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "An unexpected error occurred";
}

/**
 * Extract error code from API error
 */
export function getErrorCode(error: unknown): string | undefined {
  if (isApiError(error)) {
    return error.error.code;
  }
  return undefined;
}
